<div class="pt-3 pl-md-4" *ngIf="!accountService.getMyAccount().can_manage_members">
  <h2>You do not have permission to manage entry pass discounts.</h2>
</div>

<div class="pt-3 pl-md-4" *ngIf="serverError !== null">
  <h2>Server Error: {{ serverError }}</h2>
</div>

<div class="pt-3 pl-md-4 mb-6"
     *ngIf="accountService.getMyAccount().can_manage_members && serverError === null">

  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin">
        Admin
      </a></li>
      <li class="breadcrumb-item"><a routerLink="/memberships-and-passes">
        Memberships & Passes
      </a></li>
      <li class="breadcrumb-item active" aria-current="page">
        Entry Pass Discounts
      </li>
    </ol>
  </nav>

  <h2>
    Entry Pass Discounts
    <span *ngIf="loadingResults" class="text-secondary">- Loading...</span>
    <span *ngIf="!loadingResults && resultList && resultList.results">({{ resultList.count.toLocaleString() }})</span>
  </h2>

  <div class="alert" role="alert"
       [class.alert-success]="history.state.feedback.status == 'success'"
       [class.alert-info]="history.state.feedback.status == 'info'"
       *ngIf="history && history.state && history.state.feedback">
    {{ history.state.feedback.text }}
  </div>

  <div class="row">
    <div class="col-xl-5 col-12 mb-3">
      <input type="text" class="form-control"
             placeholder="Filter discounts by code and name"
             [(ngModel)]="filters.search"
             (ngModelChange)="handleFilterChange()">
    </div>
    <div class="col-xl-7 col-12 mb-3 clearfix">
      <div class="float-right">
        <a class="btn btn-success" routerLink="/entry-pass-settings/discounts/add">
          Create New Discount
        </a>
      </div>
    </div>
  </div>

  <div class="rounded-table-wrapper table-responsive-lg">
    <table class="table table-hover">

      <thead>
      <tr>
        <th scope="col">Type</th>
        <th scope="col">Code</th>
        <th scope="col">Name</th>
        <th scope="col">Amount</th>
        <th scope="col">Start Date</th>
        <th scope="col">End Date</th>
        <th scope="col">Entry Passes</th>
      </tr>
      </thead>

      <tbody *ngIf="resultsPresent()">
      <tr *ngFor="let discount of resultList.results"
          style="cursor: pointer;"
          routerLink="/entry-pass-settings/discounts/{{ discount.id }}">
        <td>{{ discount.is_automatic ? 'Automatic' : 'Code' }}</td>
        <td>
          <span *ngIf="discount.code">{{ discount.code }}</span>
          <span *ngIf="!discount.code" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.name">{{ discount.name }}</span>
          <span *ngIf="!discount.name" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.discount_type === EntryPassDiscountType.currency">
            {{ orgConfig.formatCurrency(discount.amount) }}
          </span>
          <span *ngIf="discount.discount_type === EntryPassDiscountType.percentage">
            {{ discount.amount }}%
          </span>
        </td>
        <td>
          <span *ngIf="discount.start_date">{{ dateStringFromISO8601(discount.start_date) }}</span>
          <span *ngIf="!discount.start_date" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.end_date">{{ dateStringFromISO8601(discount.end_date) }}</span>
          <span *ngIf="!discount.end_date" class="text-muted">None</span>
        </td>
        <td>
          <span *ngIf="discount.entry_pass_names.length === 1">1 pass</span>
          <span *ngIf="discount.entry_pass_names.length !== 1">{{ discount.entry_pass_names.length }} passes</span>
          <ng-container *ngFor="let epName of discount.entry_pass_names.slice(0, 5)">
            <br>
            <i>{{ epName }}</i>
          </ng-container>
          <ng-container *ngIf="discount.entry_pass_names.length > 5">
            <br>
            <i>&#8230;</i>
          </ng-container>
        </td>
      </tr>
      </tbody>

      <tbody *ngIf="!resultsPresent()">
      <tr>
        <td colspan="99">
          {{ loadingResults ? 'Loading...' : 'No discounts' }}
        </td>
      </tr>
      </tbody>

    </table>
  </div>

  <div class="row">
    <div class="col-sm mb-2">
      <label for="resultsPerPage" class="pr-1 align-middle">
        Results per page:
      </label>
      <select id="resultsPerPage" class="form-control d-inline-block" style="width:80px;"
              [(ngModel)]="pageSize" (change)="pageNumber = 1;loadDiscounts()">
        <option [ngValue]="10">10</option>
        <option [ngValue]="25">25</option>
        <option [ngValue]="50">50</option>
        <option [ngValue]="100">100</option>
      </select>
    </div>
    <div class="col-sm">
      <nav aria-label="Customer pagination">
        <ul class="pagination justify-content-end">
          <li class="page-item" [class.disabled]="pageNumber <= 1">
            <button class="page-link" aria-label="Previous" [disabled]="pageNumber <= 1"
               (click)="setPage(pageNumber - 1)">
              <span aria-hidden="true">&laquo;</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 2">
            <button class="page-link" (click)="setPage(pageNumber - 2)">
              {{ pageNumber - 2 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber > 1">
            <button class="page-link" (click)="setPage(pageNumber - 1)">
              {{ pageNumber - 1 }}
            </button>
          </li>
          <li class="page-item active" aria-current="page">
            <button class="page-link" disabled>
              {{ pageNumber }}
              <span class="sr-only">(current)</span>
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < lastPageNumber()">
            <button class="page-link" (click)="setPage(pageNumber + 1)">
              {{ pageNumber + 1 }}
            </button>
          </li>
          <li class="page-item" *ngIf="pageNumber < (lastPageNumber() - 1)">
            <button class="page-link" (click)="setPage(pageNumber + 2)">
              {{ pageNumber + 2 }}
            </button>
          </li>
          <li class="page-item" [class.disabled]="pageNumber >= lastPageNumber()">
            <button class="page-link" aria-label="Next" [disabled]="pageNumber >= lastPageNumber()"
               (click)="setPage(pageNumber + 1)">
              <span aria-hidden="true">&raquo;</span>
            </button>
          </li>
        </ul>
      </nav>
    </div>
  </div>

</div>
